import React from 'react';

import { ArticleSlideWrapper, ReadMoreLink } from '../styles/articleSlide.style';

/**
 * Article Slide
 * @param {object} props incoming props
 * @returns {XML} Outcoming component
 */
const ArticleSlide = ({
  title, subtitle, landscapeImage, articleSlug,
}) => {
  const imageUrl = landscapeImage && landscapeImage.file && landscapeImage.file.url;
  return (
    <ArticleSlideWrapper>
      {imageUrl && <div className="article-bg" style={{ backgroundImage: `url(${imageUrl})` }} />}
      <div className="xfl-article-slide__content">
        {subtitle && <h4>{subtitle}</h4>}
        {title && <h3>{title}</h3>}
        <ReadMoreLink to={`/articles/${articleSlug}`}>
          <span>Read Full Story</span>
        </ReadMoreLink>
      </div>
    </ArticleSlideWrapper>
  );
};

export default ArticleSlide;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/components/articleSlide.js